export const primary = "#FF8A00";
export const primaryLight = "#FFC000";
export const black = "#5C5C5C";
export const light = "#FCE7B9"